<template>
  <component
    v-if="columnConfig.template"
    :is="columnConfig.template"
    :row="element"
    v-bind="columnConfig.getBind(thisComponent, scope)"
    v-on="innerListeners"
  ></component>
  <span v-else-if="columnConfig.prop">
    {{ displayValue }}
  </span>
</template>

<script>
export default {
  name: "card-section-element-card-field",
  props: {
    columnConfig: {type: Object, required: true},
    element: {type: Object, required: true},
  },
  data() {
    return {
      thisComponent: this,
    }
  },
  computed: {
    scope() {
      return {row: this.element};
    },
    displayValue() {
      return this.$companyConfiguration.helpers.getObjectPropByString(this.element, this.columnConfig.prop);
    },
    innerListeners() {
      return {
        ...this.columnConfig.getVon(this.thisComponent, this.scope),
        'elements-changed': this.elementsChanged,
      };
    },
  },
  methods: {
    elementsChanged() {
      this.$emit('elements-changed');
    },
  }
}
</script>
